import { render, staticRenderFns } from "./ManageClientBasic.vue?vue&type=template&id=1fee8525&scoped=true"
import script from "./ManageClientBasic.vue?vue&type=script&lang=ts"
export * from "./ManageClientBasic.vue?vue&type=script&lang=ts"
import style0 from "./ManageClientBasic.vue?vue&type=style&index=0&id=1fee8525&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fee8525",
  null
  
)

export default component.exports